import React, { useEffect, useState } from "react";
import './style.scss';

const Thumbprint = () => {

    const user = JSON.parse(localStorage.getItem('user'));

    const secretCode = `${user.thumbprint}`;
    let opacity = 0.1;

    if (user && user.hasOwnProperty('thumbprint_settings') && user.thumbprint_settings.opacity && user.thumbprint_settings.opacity.length > 0) {
        opacity = user.thumbprint_settings.opacity[0].value;
    }

    const showHeartIcon = () => {
        return <><i className="fa-regular fa-heart" /></>;
    };

    return <>
        <div className={'thumbprint-container thumbprint-top-left'} style={{ color: `hsl(231, 9%, 15%, ${parseFloat(opacity)})` }}>
            {showHeartIcon()}{secretCode}{showHeartIcon()}
        </div>

        <div className={'thumbprint-container  thumbprint-top-right'} style={{ color: `hsl(231, 9%, 15%, ${parseFloat(opacity)})` }}>
            {showHeartIcon()}{secretCode}{showHeartIcon()}
        </div>

        <div className={'thumbprint-container thumbprint-center'} style={{ color: `hsl(231, 9%, 15%, ${parseFloat(opacity)})` }}>
            {showHeartIcon()}{secretCode}{showHeartIcon()}
        </div>

        <div className={'thumbprint-container thumbprint-bottom-left'} style={{ color: `hsl(231, 9%, 15%, ${parseFloat(opacity)})` }}>
            {showHeartIcon()}{secretCode}{showHeartIcon()}
        </div>

        <div className={'thumbprint-container thumbprint-bottom-right'} style={{ color: `hsl(231, 9%, 15%, ${parseFloat(opacity)})` }}>
            {showHeartIcon()}{secretCode}{showHeartIcon()}
        </div>
    </>;
};

export default Thumbprint;
